import { useLayoutEffect } from 'react'
import { type FunctionComponent } from 'react'

let scrollToTopRequested = false

export function requestScrollToTop() {
  scrollToTopRequested = true
}

export function consumeScrollToTopRequest() {
  const requested = scrollToTopRequested
  scrollToTopRequested = false
  return requested
}

export const ScrollToTop: FunctionComponent = () => {
  useLayoutEffect(() => {
    if (consumeScrollToTopRequest()) {
      window.scrollTo(0, 0)
    }
  }, [])

  return null
}
